// extracted by mini-css-extract-plugin
export default {"textCenter":"Login_textCenter__GLJNj","textRight":"Login_textRight__zQ5gA","textLeft":"Login_textLeft__3piMp"};